import { generate } from '@/utils/request';
const config = {
  prefix: '/simp/v1',
  items: [
    // 分页查询模板头信息列表
    { key: 'getImportTemplateHeaders', url: '/{organizationId}/template-headers', method: 'GET' },
    /** 新增 */
    { key: 'addImportTemplateHeaders', url: '/{organizationId}/template-headers', method: 'POST' },
    /** 修改 */
    { key: 'putImportTemplateHeaders', url: '/{organizationId}/template-headers', method: 'PUT' },
    /** 删除 */
    {
      key: 'deleteImportTemplateHeaders',
      url: '/{organizationId}/template-headers',
      method: 'DELETE',
    },
    /** 查询 */
    {
      key: 'getDetailImportTemplateHeaders',
      url: '/{organizationId}/template-headers/{templateId}',
      method: 'GET',
    },
    /** 导出Csv模板 */
    {
      key: 'exportCsvImportTemplateHeaders',
      url: '/{organizationId}/template/{templateCode}/csv',
      method: 'GET',
      rType: 2,
    },
    /** 导出Excel模板 */
    {
      key: 'exportExcelImportTemplateHeaders',
      url: '/{organizationId}/template/{templateCode}/excel',
      method: 'GET',
      rType: 2,
    },

    /** ********************** 模板行部分 ********************** */

    /** 通过目标id查询模板行信息 */
    {
      key: 'getTemplateLines',
      url: '/{organizationId}/template-lines',
      method: 'GET',
    },
    /** 通过模板行id进行删除 */
    {
      key: 'deleteTemplateLines',
      url: '/{organizationId}/template-lines',
      method: 'DELETE',
    },
    /** 创建模板行信息 */
    {
      key: 'addTemplateLines',
      url: '/{organizationId}/template-lines',
      method: 'POST',
    },
    /** 更新模板行信息 */
    {
      key: 'putTemplateLines',
      url: '/{organizationId}/template-lines',
      method: 'PUT',
    },
    /** 通过行id查询模板行信息 */
    {
      key: 'getTemplateLinesDetail',
      url: '/{organizationId}/template-lines/{lineId}',
      method: 'GET',
    },
  ],
};
export default {
  ...generate(config),
};
